import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../../service/utils.service';
import { GlobalConfig } from '../../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ConformMessageComponent } from '../../../conform-message/conform-message/conform-message.component';
@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.css']
})
export class PropertiesComponent implements OnInit {
  isList: Boolean = true;
  constructor(
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private modalService: BsModalService,
  ) { }
  bsModalRef: BsModalRef;

  isAgent: Boolean = false;
  globle: any = "https://www.dubaisale.com/property/";
  agentId: any = '';
  noLatLong: any = false;
  totalItems: any = Number;
  userId: any = "";
  totalFeatured: any = Number;
  totalPremium: any = Number;
  property: any[] = [];
  categoty: any[] = [];
  agents: any[] = [];
  propertyIds: any[] = [];
  beds: any[]=[
    {id:"Studio",value:"ST"},
    {id:"1 Bed",value:"1"},
    {id:"2 Beds",value:"2"},
    {id:"3 Beds",value:"3"},
    {id:"4 Beds",value:"4"},
    {id:"5 Beds",value:"5"},
    {id:"6+ Beds",value:"6"}]
  featureds: any[] = [
    { featured: 0, value: "Standard" }, 
    { featured: 1, value: "Featured" },
    { featured: 2, value: "Premium" }
  ];
  checkAll: Boolean = false;
  page: any = { pageNumber: 1, pageSize: 20, referenceNumber: '', featured: 0, propertyType: 0, agentId: 0, areaName: '', subAreaName: '', beds: '', status: 1, subSubAreaName:''};
  ngOnInit() {
    const roles = localStorage.getItem("role");

    this.setPermissions(roles);
    this.getCategories();
    this.GetAgents();
    this.getPropertyAsync();
  }
  setPermissions(roles) {
    const userId = Number(JSON.parse(localStorage.getItem("profile")).nameid);
    const data = this;
    if (roles != null) {
      const roleName = roles.split(",");
      roleName.forEach(function (value) {
        switch (value) {
          case "agents":
            data.agentId = userId;
            data.isAgent = true;
            break;

          default:
            break;
        }

      });
    }
  }

  getCategories() {
    this.servicesComponent.getCategories()
      .then((response: any) => {
        if (response.success) {
          this.categoty = response.receiveObj;
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getPropertyAsync() {
    if (this.agentId > 0) {
      this.page.agentId = this.agentId;
    }
    if (this.noLatLong) {
      this.page.noLatLong = this.noLatLong;
    }
    this.servicesComponent.getPropertyAsync(this.page)
      .then((response: any) => {
        if (response.receiveObj.success) {
          this.property = response.receiveObj.result.data;
          this.totalItems = response.receiveObj.result.total_rows;
          if (this.property.length > 0) {
            this.totalFeatured = response.receiveObj.result.data[0].featuredCount;
            this.totalPremium = response.receiveObj.result.data[0].premiumCount;
          }
          this.isList = this.property.length > 0 ? true : false;
        }
      })
      .catch(error => {
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  GetAgents() {
    this.servicesComponent.GetAgents()
      .then((response: any) => {
        if (response.success) {
          this.agents = response.receiveObj.filter(item => item.status === 1);
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  pageChanged(event: any): void {
    this.page.pageNumber = event.page;
    this.page.pageSize = event.itemsPerPage;
    this.getPropertyAsync();
  }

  searchProperty() {
    this.page.pageNumber = 1;
    this.getPropertyAsync();
  }

  updateProperty(id) {
    this.router.navigate(['./updateProperty', id]);
  }

  enableDisableProperty(isEnable) {
    const propertyIdsValue = [];
    this.property.forEach(function (value) {
      if (value.isDisable === true) {
        propertyIdsValue.push({ id: value.id, isEnable: isEnable });
      }
    });

    this.propertyIds = propertyIdsValue;
    if (this.propertyIds.length > 0) {
      this.result();
    }
  }

  disableSingle(id, isEnable) {
    const propertyIdsValue = [];
    this.propertyIds = [];
    propertyIdsValue.push({ id: id, isEnable: isEnable });
    this.propertyIds = propertyIdsValue;
    this.result();
  }

  selectAllCheckBox() {
    this.propertyIds = [];
    const stateIdsValue = [];
    if (!this.checkAll) {
      this.property.forEach(function (value) {
        value.isDisable = true;
      });
    }

    else {
      this.propertyIds = [];
      this.property.forEach(function (value) {
        value.isDisable = false;
      });
    }
  }

  delete(id) {
    if (id > 0) {
      this.servicesComponent.deleteProperty(id)
        .then((response: any) => {
          if (response.success == true) {
            this.page.pageNumber = 1;
            this.getPropertyAsync();
            this.toastr.success('property delete successfully.', 'Success!');
          } 
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    }
  }

  result() {
    this.servicesComponent.enableDisableProperty(this.propertyIds)
      .then((response: any) => {
        if (response.success == true) {
          this.page.pageNumber = 1;
          this.getPropertyAsync();
          this.toastr.success('property enable / disable successfully.', 'Success!');
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  managefeatured(value, propertyId) {
    this.servicesComponent.managefeatured(value, propertyId)
      .then((response: any) => {
        if (response.receiveObj == 0) {
          this.getPropertyAsync();
          this.toastr.success('property standard  successfully.', 'Success!');
        }
        else if (response.receiveObj == 1) {
          this.getPropertyAsync();
          this.toastr.success('property featured  successfully.', 'Success!');
        } else if (response.receiveObj == 2) {
          this.getPropertyAsync();
          this.toastr.success('property premium  successfully.', 'Success!');
        }
        else if (response.receiveObj == -1) {
          this.getPropertyAsync();
          this.toastr.info('agent featured quota over .', 'Success!');
        } 
        else if (response.receiveObj == -2) {
          this.getPropertyAsync();
          this.toastr.info('agent premium quota over .', 'Success!');
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  viewProperty(value) {
    var myStr = value.propertyTitle.replace(/(^\s+|[^a-zA-Z0-9 ]+|\s+$)/g, "");
    myStr = myStr.toLowerCase().replace(/\s+/g, "-");
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = this.globle + myStr + '-' + value.id;
    link.click();
  }

  clearProperty() {
    this.page.referenceNumber = '';
    this.page.featured = 0;
    this.page.propertyType = 0;
    this.page.agentId = 0;
    this.page.areaName = '';
    this.page.subAreaName = '';
    this.page.beds = '';
    this.page.status = 1;
    this.searchProperty();
  }

  callMessgaeConform(id: any) {
    const subject = new Subject<any>();
    this.config.confirmService = { confirmMessage: 'Do you want to delete the property?' };
    this.bsModalRef = this.modalService.show(ConformMessageComponent);
    this.bsModalRef.content.subject = subject;
    subject.asObservable().subscribe((data) => {
      if (data) {
        this.delete(id);
      }
      this.bsModalRef.hide();
    });
  }

  keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.getPropertyAsync();
    }
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/propertiesManagement/property/properties/properties.component.ts